import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';

import extendSignUpModal from './components/SignUpModal';
import extendLogInButtons from './components/LogInButtons';
import extendHeaderSecondary from './components/HeaderSecondary';
import extendSettingsPage from './components/SettingsPage';
import extendLogInModal from './components/LogInModal';

app.initializers.add('foskym/flarum-cjlu-bbs-auth', () => {
  extendSignUpModal();
  extendLogInButtons();
  extendHeaderSecondary();
  extendSettingsPage();
  extendLogInModal();
});
